import * as React from 'react'
import PropTypes from 'prop-types'

export const headingLevels = ['1', '2', '3', '4', '5', '6'] as const
export type HeadingLevel = (typeof headingLevels)[number]

export interface BaseHeadingTagProps
  extends React.DetailedHTMLProps<
    React.HTMLAttributes<HTMLHeadingElement>,
    HTMLHeadingElement
  > {
  children?: React.ReactNode
  /**
   * The semantic HTML section heading level.
   */
  level: HeadingLevel
}

export const BaseHeadingTag = ({
  level,
  children,
  ...restProps
}: BaseHeadingTagProps) => {
  switch (level) {
    case '1':
      return <h1 {...restProps}>{children}</h1>
    case '2':
      return <h2 {...restProps}>{children}</h2>
    case '3':
      return <h3 {...restProps}>{children}</h3>
    case '4':
      return <h4 {...restProps}>{children}</h4>
    case '5':
      return <h5 {...restProps}>{children}</h5>
    default:
      return <h6 {...restProps}>{children}</h6>
  }
}

BaseHeadingTag.propTypes = {
  children: PropTypes.node,
  level: PropTypes.oneOf(headingLevels).isRequired,
}
